<template>
    <div class="row">
        <div class="text-center col-12">
            <h3 class="mt-5">{{ $t("passwordProcessTitle") }}</h3>
            <h5 class="text-secondary font-weight-normal">
                {{ $t("passwordProcessHint") }}
            </h5>
            <div class="multisteps-form">
                <!--progress bar-->
                <div class="row mb-4">
                    <div class="mx-auto my-3 col-12 col-lg-8">
                        <div class="multisteps-form__progress">
                            <button class="multisteps-form__progress-btn" type="button" title="User Info"
                                :class="activeStep >= 0 ? activeClass : ''">
                                <span>{{ $t("passwordStepCurrent") }}</span>
                            </button>
                            <button class="multisteps-form__progress-btn" type="button" title="Address"
                                :class="activeStep >= 1 ? activeClass : ''">
                                <span>{{ $t("passwordStepCreate") }}</span>
                            </button>
                            <button class="multisteps-form__progress-btn" type="button" title="Order Info"
                                :class="activeStep === 2 ? activeClass : ''">
                                <span>{{ $t("passwordStepConfirm") }}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <!--form panels-->
                <div style="display: flex; justify-content: center;">
                    <div class="row">
                        <div class="col-12 col-lg-12">
                            <div class="card" style="width: 550px;">
                                <div class="card-header">
                                    <h4>{{ cardHeader[activeStep].head }}</h4>
                                    <h6 class="text-secondary font-weight-normal">{{ cardHeader[activeStep].title }}
                                    </h6>
                                </div>
                                <div class="card-body">
                                    <el-input v-if="activeStep == 0" v-model="currentPassword"
                                        type="password" placeholder="" size="large" style="width: 75%;"
                                        autocomplete="new-password" @keyup.enter="nextStep" />
                                    <el-input v-if="activeStep == 1" v-model="this.newPassword" autocomplete="off"
                                        type="password" placeholder="" size="large" style="width: 75%;"
                                        @keyup.enter="nextStep" />
                                    <el-input v-if="activeStep == 2" v-model="this.confirmPassword" autocomplete="off"
                                        type="password" placeholder="" size="large" style="width: 75%;"
                                        @keyup.enter="nextStep" />
                                    <div v-if="message != null" style="height: 0;">
                                        <p style="margin-top: 10px;" class="text-danger text-xs mt-2"><i
                                                class="bi bi-exclamation-circle-fill"></i> {{ this.message }}</p>
                                    </div>
                                    <div v-if="activeStep == 1">
                                        <span style="display: flex;" class="mt-1">
                                            <br>
                                            <div class="text-xxs"
                                                :style="v$.is12.$error ? { color: 'red' } : { color: 'green' }"><i
                                                    :class="v$.is12.$error ? { 'fas fa-times': true } : { 'fa fa-check': true }"
                                                    class="text-xxs"></i> &nbsp;Ən azı 12 simvoldan ibarət</div>
                                            &nbsp;&nbsp;&nbsp;
                                            <div class="text-xxs"
                                                :style="v$.hasUpperCase.$error ? { color: 'red' } : { color: 'green' }">
                                                <i :class="v$.hasUpperCase.$error ? { 'fas fa-times': true } : { 'fa fa-check': true }"
                                                    class="text-xxs"></i> &nbsp;Böyük və kiçik hərflərdən
                                                istifadə edin (A-Z, a-z).
                                            </div>
                                            &nbsp;&nbsp;&nbsp;
                                        </span>
                                        <span style="display: flex;">
                                            <div class="text-xxs"
                                                :style="v$.hasNumber.$error ? { color: 'red' } : { color: 'green' }"><i
                                                    :class="v$.hasNumber.$error ? { 'fas fa-times': true } : { 'fa fa-check': true }"
                                                    class="text-xxs"></i> &nbsp;Rəqəmlərdən istifadə edin
                                                (0-9).</div>
                                            &nbsp;&nbsp;&nbsp;
                                            <div class="text-xxs"
                                                :style="v$.hasSpecialChar.$error ? { color: 'red' } : { color: 'green' }">
                                                <i :class="v$.hasSpecialChar.$error ? { 'fas fa-times': true } : { 'fa fa-check': true }"
                                                    class="text-xs"></i> &nbsp;Xüsusi simvollar daxil
                                                edin (məsələn, !, @, #, $, %, ^, &, *).
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-sm-3">
                                        <button v-if="activeStep != 0" type="button" class="mb-3 btn btn-md bg-gradient-info"
                                            @click="prevStep">
                                            <i class="fa fa-angle-left"></i> Əvvəlki
                                        </button>
                                    </div>
                                    <div class="col-sm-6">

                                    </div>
                                    <div class="col-sm-3">
                                        <button type="button" class="mb-3 btn btn-md bg-gradient-success"
                                            @click="nextStep">
                                            Sonraki <i class="fa fa-angle-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Source from "@/project/Source/claim.js";
import CryptoJS from "crypto-js";
import { weblink } from '@/project/Source/helper.js'
import { required } from '@vuelidate/validators'
import useValidate from '@vuelidate/core';

export default {
    name: "Password",
    data() {
        return {
            activeClass: "js-active position-relative",
            v$: useValidate(),
            activeStep: 0,
            newPassword: '',
            confirmPassword: null,
            message: null,
            formSteps: 2,
            currentPassword: null
        };
    },
    computed: {
        cardHeader() {
            return [
                { head: this.$t("passwordStepCurrentHead"), title: this.$t("passwordStepCurrentBody") },
                { head: this.$t("passwordStepCreateHead"), title: this.$t("passwordStepCreateBody") },
                { head: this.$t("passwordStepConfirmHead"), title: this.$t("passwordStepConfirmBody") }
            ];
        }
    },
    validations() {
        return {
            newPassCheck: {
                newPassCheck(val) {
                    return val === this.newPassword || this.activeStep != 2;
                }
            },
            is12: {
                required: this.newPassword.length > 11 ? !required : required
            },
            hasUpperCase: {
                required: /[A-Z]/.test(this.newPassword) && /[a-z]/.test(this.newPassword) ? !required : required
            },
            hasNumber: {
                required: /\d/.test(this.newPassword) ? !required : required
            },
            hasSpecialChar: {
                required: /[!@#$%^&*]/.test(this.newPassword) ? !required : required
            }
        }
    },
    mounted() {
        this.v$.is12.$validate()
        this.v$.hasUpperCase.$validate()
        this.v$.hasNumber.$validate()
        this.v$.hasSpecialChar.$validate()
    },
    methods: {
        createPassword() {
            const data = {
                requestCorrelationId: "string",
                oldPassword: this.currentPassword,
                newPassword: this.newPassword,
                userId: JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem("user"), 'secret_key').toString(CryptoJS.enc.Utf8)).userId
            }

            Source.ChangePassword(data).then(() => {
                window.location.href = weblink + "signIn";
                window.localStorage.setItem('jwt', CryptoJS.AES.encrypt(JSON.stringify("none"), 'secret_key').toString())
                window.localStorage.setItem('roles', CryptoJS.AES.encrypt(JSON.stringify([{ id: null }]), 'secret_key').toString())
                window.localStorage.setItem('user', CryptoJS.AES.encrypt(JSON.stringify([{ id: null }]), 'secret_key').toString())
            })
        },
        async CheckUser() {
            const data = {
                "requestCorrelationId": "string",
                "username": JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem("user"), 'secret_key').toString(CryptoJS.enc.Utf8)).login,
                "password": this.currentPassword
            }
            let value = null
            await Source.Login(data).then(response => {
                if (response.data.data[0] != undefined) {
                    if (!response.data.data[0].user.locked && response.data.data[0].user.authenticated) {
                        value = true
                    }
                    else {
                        value = false
                    }
                }
                else {
                    value = false
                }
            })
            return value
        },
        async nextStep() {
            if (this.activeStep == 0) {
                if (!await this.CheckUser()) {
                    this.message = this.$t("passwordWrongCurrent")
                    return
                }
            }
            if (this.activeStep == 1) {
                this.v$.$validate()
                if (this.v$.$error) {
                    return
                }
            }
            if (this.activeStep == 2) {
                if (this.confirmPassword != this.newPassword) {
                    this.message = this.$t("passwordMismatch")
                    return
                } else {
                    this.createPassword()
                    return
                }
            }
            this.message = null
            if (this.activeStep < this.formSteps) {
                this.activeStep += 1;
            } else {
                this.activeStep -= 1;
            }
        },
        prevStep() {
            if (this.activeStep > 0) {
                this.activeStep -= 1;
            }
        },
    },
};
</script>